import { render, staticRenderFns } from "./ProductsRouter.vue?vue&type=template&id=5479738a&scoped=true&"
import script from "./ProductsRouter.vue?vue&type=script&lang=js&"
export * from "./ProductsRouter.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRouter.vue?vue&type=style&index=0&id=5479738a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479738a",
  null
  
)

export default component.exports